import React from 'react'


import CatalogueContent from './CatalogueContent'


function CatalogueStructure() {
    return (
        <div>
            {/* second navbar */}
            <CatalogueContent/>
            
            {/* footer */}
        </div>
    )
}

export default CatalogueStructure
